import { render, staticRenderFns } from "./PickUpEvents.vue?vue&type=template&id=88ae81c4&lang=pug&"
import script from "./PickUpEvents.vue?vue&type=script&lang=js&"
export * from "./PickUpEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports